import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=7e456359&scoped=true"
import script from "./SimpleDialog.vue?vue&type=script&lang=ts"
export * from "./SimpleDialog.vue?vue&type=script&lang=ts"
import style0 from "./SimpleDialog.vue?vue&type=style&index=0&id=7e456359&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e456359",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e456359')) {
      api.createRecord('7e456359', component.options)
    } else {
      api.reload('7e456359', component.options)
    }
    module.hot.accept("./SimpleDialog.vue?vue&type=template&id=7e456359&scoped=true", function () {
      api.rerender('7e456359', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/SimpleDialog.vue"
export default component.exports